import gql from 'graphql-tag';
import {
  reviewFields,
  companyStackFields,
  stackupServiceFields,
  stackupStackDecisionFields,
  descriptionFields
} from './fragments';
import {
  serviceFields,
  stackFields,
  stackDecisionFields,
  serviceFieldsTool
} from '../shared/fragments';

export const stackupBySlug = gql`
  query stackupBySlug($slug: String!) {
    stackupBySlug(slug: $slug) {
      cachedAlternativeTools
      contactEnabledTools {
        id
      }
      jobs {
        count
      }
      featuredPosts {
        count
      }
      applesToOranges
      content1
      content2
      topContent
      bottomContent
      packageStackup
      screenshotImageUrl
      function
      path
      title
      seoUpdatedAt
      cachedStackDecisionsGetAdvice
      privateStackDecisionsGetAdvice(first: 3) {
        count
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...stackupStackDecisionFields
            decisionType
            fromTools {
              ...serviceFieldsTool
            }
            toTools {
              ...serviceFieldsTool
            }
            subjectTools {
              ...serviceFieldsTool
            }
            stack {
              ...stackFields
            }
            answers {
              count
              pageInfo {
                hasNextPage
                endCursor
              }
              edges {
                node {
                  ...stackDecisionFields
                }
              }
            }
          }
        }
      }
      cachedStackDecisions
      privateStackDecisions(first: 5) {
        count
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...stackupStackDecisionFields
          }
        }
      }
      cachedFooterRelatedStackups
      footerTopStackups {
        title
        path
      }
      footerTrendingStackups {
        title
        path
      }
    }
  }
  ${stackupStackDecisionFields}
  ${serviceFieldsTool}
  ${stackFields}
  ${stackDecisionFields}
`;

export const stackDecisions = gql`
  query stackDecisions($slug: String!, $after: String!) {
    stackupBySlug(slug: $slug) {
      stackDecisions(first: 3, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...stackupStackDecisionFields
          }
        }
      }
    }
  }
  ${stackupStackDecisionFields}
`;

export const privateStackDecisions = gql`
  query privateStackDecisions($slug: String!, $after: String!) {
    stackupBySlug(slug: $slug) {
      privateStackDecisions(first: 3, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...stackupStackDecisionFields
          }
        }
      }
    }
  }
  ${stackupStackDecisionFields}
`;

export const stackupReviews = gql`
  query stackupReviews($slug: String!, $after: String!) {
    stackupBySlug(slug: $slug) {
      reviews(first: 2, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...reviewFields
          }
        }
      }
    }
  }
  ${reviewFields}
`;

export const stackupDescriptions = gql`
  query stackupDescriptions($slug: String!, $after: String!) {
    stackupBySlug(slug: $slug) {
      descriptions(first: 2, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...descriptionFields
          }
        }
      }
    }
  }
  ${descriptionFields}
`;

export const stackupToolCompanyStacksUsing = gql`
  query stackupToolCompanyStacksUsing($slug: ID!, $after: String!) {
    tool(id: $slug) {
      id
      companyStacksUsing(first: 7, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...companyStackFields
          }
        }
      }
    }
  }
  ${companyStackFields}
`;

export const stackupToolAllToolIntegrations = gql`
  query stackupToolAllToolIntegrations($slug: ID!, $after: String!) {
    tool(id: $slug) {
      id
      allToolIntegrations(first: 7, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...stackupServiceFields
          }
        }
      }
    }
  }
  ${stackupServiceFields}
`;

export const privateStacksWith = gql`
  query privateStacksWith($slug: ID!, $after: String!) {
    tool(id: $slug) {
      id
      privateStacksList: privateStacks(first: 7, after: $after) {
        edges {
          node {
            name
            imageUrl
            thumbUrl
            path
            private
          }
        }
      }
    }
  }
`;

export const teamWith = gql`
  query fetchTeams($slug: ID!) {
    teams: toolTeams(id: $slug) {
      edges {
        node {
          name
          imageUrl
          thumbUrl
          path: canonicalUrl
          private
        }
      }
    }
  }
`;

export const stackupTool = gql`
  query stackupTool($slug: ID!) {
    tool(id: $slug) {
      id
      legacyThirdPartyId
      slug
      contactEnabled
      contactButtonText
      contactFlow
      contactButtonSponsorId
      name
      packageManager {
        name
        slug
        miniImageUrl
        path
      }
      type
      imageUrl
      thumbUrl
      thumbRetinaUrl
      canonicalUrl
      stacks
      votes
      jobs
      followersCount
      followingTool
      latestVersionNumber
      license {
        name
        url
      }
      dependentPackagesCount
      membersCount
      vulnerabilities {
        edges {
          node {
            severity
            name
          }
        }
      }
      hackernewsOnlineMentionsCount
      redditOnlineMentionsCount
      stackOverflowOnlineMentionsCount
      githubForksCount
      githubStarsCount
      githubUpdatedAt
      description
      pricingUrl
      popularity
      path
      pressUrl
      relatedStackupsCount
      layer {
        name
        slug
      }
      category {
        name
        slug
      }
      function {
        name
        slug
      }
      cachedPros
      cachedCons
      privateStacksList: privateStacks(first: 7) {
        edges {
          node {
            name
            imageUrl
            thumbUrl
            path
            private
          }
        }
      }
      teams(first: 7) {
        edges {
          node {
            name
            imageUrl
            thumbUrl
            path: canonicalUrl
            private
          }
        }
      }
      cachedCompanyStacksUsing
      cachedAllToolIntegrations
      officialArticles(first: 5) {
        edges {
          node {
            title
            importSource
            outboundUrl
            discussionScore
            publishedAt
            commentCount
          }
        }
      }
    }
  }
`;

export const stackup = gql`
  query stackup($id: ID!) {
    stackup(id: $id) {
      stackDecisions {
        user {
          id
          username
          title
          companyName
          imageUrl
          displayName
        }
        company {
          imageUrl
          name
        }
        link {
          url
          title
        }
        publicId
        createdAt
        id
        htmlContent
        viewCount
        upvotesCount
        services {
          name
          path
          id
          imageUrl
        }
        topics {
          name
          id
        }
      }
    }
  }
`;

export const stackupJobs = gql`
  query stackupBySlug($slug: String!) {
    stackupBySlug(slug: $slug) {
      jobs(first: 8) {
        edges {
          node {
            name
            id
            angellistJobUrl
            title
            location
            private
            services {
              ...serviceFields
            }
            company {
              imageUrl
              name
              id
              path
            }
          }
        }
      }
    }
  }
  ${serviceFields}
`;

export const stackAdvice = gql`
  query stackAdvice($slug: String!, $after: String!) {
    stackupBySlug(slug: $slug) {
      stackDecisionsGetAdvice(first: 3, after: $after) {
        count
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...stackupStackDecisionFields
            decisionType
            fromTools {
              ...serviceFields
            }
            toTools {
              ...serviceFields
            }
            subjectTools {
              ...serviceFields
            }
            stack {
              ...stackFields
            }
            answers {
              count
              pageInfo {
                hasNextPage
                endCursor
              }
              edges {
                node {
                  ...stackDecisionFields
                }
              }
            }
          }
        }
      }
    }
  }
  ${stackupStackDecisionFields}
  ${stackDecisionFields}
  ${serviceFields}
  ${stackFields}
`;

export const stackPrivateAdvice = gql`
  query stackPrivateAdvice($slug: String!, $after: String!) {
    stackupBySlug(slug: $slug) {
      privateStackDecisionsGetAdvice(first: 3, after: $after) {
        count
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...stackupStackDecisionFields
            decisionType
            fromTools {
              ...serviceFields
            }
            toTools {
              ...serviceFields
            }
            subjectTools {
              ...serviceFields
            }
            stack {
              ...stackFields
            }
            answers {
              count
              pageInfo {
                hasNextPage
                endCursor
              }
              edges {
                node {
                  ...stackDecisionFields
                }
              }
            }
          }
        }
      }
    }
  }
  ${stackupStackDecisionFields}
  ${stackDecisionFields}
  ${serviceFields}
  ${stackFields}
`;

export const posts = gql`
  query posts($slug: String!, $after: String, $first: Int) {
    stackupBySlug(slug: $slug) {
      featuredPosts(first: $first, after: $after) {
        count
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            views
            title
            imageUrl
            publishedAt
            canonicalUrl
            previewImageUrl
            company {
              name
            }
            tools {
              id
              name
              slug
              title
              verified
              imageUrl
              canonicalUrl
              path
              votes
              fans
              stacks
              following
              followContext
            }
            favoriteStacksCount
          }
        }
      }
    }
  }
`;
